import { render, staticRenderFns } from "./StoresMapSectionModule.vue?vue&type=template&id=552793a2&"
import script from "./StoresMapSectionModule.vue?vue&type=script&lang=js&"
export * from "./StoresMapSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports